module.exports = __webpack_public_path__ + "static/media/8.b6251905.jpg";